import React from "react";
import { Flex, Text, useToken } from "@chakra-ui/react";
import { Paper } from "@equidefi/ui";
import { Icon } from "@equidefi/ui/icon";
import { useNavigate } from "react-router";
import { useWorkflowContext } from "@/pages/workflow/context/WorkflowContext";

const LockView = () => {
  return (
    <Flex direction="row" align="flex-end" width="24px" p={0} m={0}>
      <Icon.Lock color="#7283A0" width={24} height={24} />
    </Flex>
  );
};

const EditView = ({ page, returnTo = "kyc" }) => {
  const navigate = useNavigate();
  const { investment, offering } = useWorkflowContext();
  const [equidefiBlue] = useToken("colors", ["equidefi.blue"]);

  return (
    <Flex
      direction="row"
      cursor="pointer"
      onClick={() => {
        navigate(`/offerings/${offering.slug}/${investment.id}/${page}`, {
          state: {
            returnTo,
            skip_transition: true,
            refresh: true,
          },
        });
      }}>
      <Icon.Edit color={equidefiBlue} />
      <Text color="equidefi.blue" ml={3}>
        Edit
      </Text>
    </Flex>
  );
};

const ReviewCard = ({ title, children, page, returnTo, ...rest }) => {
  let ActionView = EditView;
  if (!page) {
    ActionView = LockView;
  }

  return (
    <Paper h="full" {...rest}>
      <Flex
        direction="row"
        borderBottom="1px"
        borderColor="gray.100"
        align="flex-start"
        p={6}
        mb={5}
        justifyContent="space-around"
        h="full">
        <Flex direction="column" width="calc(100% - 24px)">
          <Text fontSize="md" mb="3" color="black" fontWeight={700}>
            {title}
          </Text>
          <Text fontSize="md" mb="0" color="gray.600">
            {children}
          </Text>
        </Flex>
        <ActionView page={page} returnTo={returnTo} />
      </Flex>
    </Paper>
  );
};

export default ReviewCard;
